/*
* Copyright (c) 2026 Send2Me, media capture and delivery platform. All rights reserved.
* Distributed under the TruVideo proprietary license.
*/
import PropTypes from 'prop-types';
import ReviewShell from './ReviewShell';

// Shown when a previous device's session on this link has lapsed (Save &
// Exit or idle timeout) and this device is taking over — a read-only
// review of everything captured so far, with notes visible, before the
// user continues into the capture flow.
const ResumeGate = ({ items, capturedFiles, serverCompleted, completedItemsMedia, assignment, workflow, branding, onOpenNotes, notes, onAddNote, onContinue, token, syncStatus, onDismissSyncStatus }) => (
  <ReviewShell
    items={items}
    capturedFiles={capturedFiles}
    serverCompleted={serverCompleted}
    completedItemsMedia={completedItemsMedia}
    assignment={assignment}
    workflow={workflow}
    branding={branding}
    heading="Check your media before starting"
    body="Review each item below. You can retake or remove any capture before submitting your media."
    onNotesClick={onOpenNotes}
    notes={notes}
    onAddNote={onAddNote}
    showNotesWarning={false}
    actionLabel="Continue"
    onAction={onContinue}
    token={token}
    syncStatus={syncStatus}
    onDismissSyncStatus={onDismissSyncStatus}
  />
);

export default ResumeGate;

ResumeGate.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      assignmentItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      type: PropTypes.string,
      description: PropTypes.string,
      required: PropTypes.bool,
      status: PropTypes.string,
    })
  ),
  capturedFiles: PropTypes.object,
  serverCompleted: PropTypes.object,
  completedItemsMedia: PropTypes.object,
  assignment: PropTypes.shape({
    expiresAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    submitterName: PropTypes.string,
    workflowName: PropTypes.string,
    customerReferenceNumber: PropTypes.string,
  }),
  workflow: PropTypes.shape({
    branding: PropTypes.shape({
      logoUrl: PropTypes.string,
    }),
  }),
  branding: PropTypes.shape({
    theme: PropTypes.string,
  }),
  onOpenNotes: PropTypes.func,
  notes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      note: PropTypes.string,
      timestamp: PropTypes.string,
    })
  ),
  onAddNote: PropTypes.func,
  onContinue: PropTypes.func.isRequired,
  token: PropTypes.string,
  syncStatus: PropTypes.shape({
    status: PropTypes.oneOf(['success', 'error']),
    message: PropTypes.string,
  }),
  onDismissSyncStatus: PropTypes.func,
};
